import type { FeedbackMessages } from './en';

const pl: FeedbackMessages = {
  qualified: {
    title: 'Dziękujemy za wzięcie udziału w tym badaniu!',
    text: 'Mogą Państwo teraz zamknąć okno przeglądarki.\n\nMamy nadzieję, że wkrótce znów się spotkamy.',
  },
  quotaFull: {
    title: 'To badanie jest zamknięte',
    text: 'Dziękujemy za zainteresowanie naszym badaniem.\n\nNiestety otrzymaliśmy już wszystkie potrzebne odpowiedzi.\n\nMamy nadzieję, że będą Państwo mogli wziąć udział w jednym z naszych przyszłych badań!',
  },
  terminated: {
    title: 'Dziękujemy za przekazanie opinii!',
    text: 'Mamy nadzieję, że wkrótce spotkamy się ponownie w ramach naszych przyszłych badań. Do tego czasu życzymy Państwu miłego dnia.\n\nProszę zamknąć to okno przeglądarki.',
  },
  mismatch: {
    title: 'Dziękujemy za zainteresowanie',
    text: 'Niestety nie należą Państwo do grupy docelowej tego konkretnego badania.\n\nMogą Państwo zamknąć tę stronę.',
  },
  error: {
    title: 'Nie możemy obsłużyć Państwa żądania',
    linkProblemDetailed:
      'Link, z którego Państwo skorzystali, ma problemy. Proszę sprawdzić, czy link w polu adresu zgadza się z tym, który Państwo otrzymali, i spróbować ponownie.',
    linkProblemGeneric:
      'Link, z którego Państwo skorzystali, ma problemy. Proszę spróbować ponownie.',
    contactPerson:
      'Jeśli problem będzie się powtarzał, prosimy poinformować o tym osobę, od której otrzymali Państwo ten link.',
  },
};

export default pl;
